import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import OpportunityInfoTab from './OpportunityInfoTab';
import DocumentsTab from '../opportunity-documents/DocumentsTab.jsx';
import OpportunityCoversionTab from './OpportunityConversionTab';
import ConversionTab from './ConversionTab';
import HunterDropdown from './HunterDropdown';

const OpportunityDetails = ({oppData}) => {
    const [activeTab, setActiveTab] = useState(0);
    const [referralData, setReferralData] = useState([]);
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const [initialPayoutValue, setInitialPayoutValue] = useState(null);
    const [showSaveButtons, setShowSaveButtons] = useState(false);
    const [isEditing, setIsEditing] = useState(false);

    const handleEditClick = () => {
        setIsEditing(!isEditing);
    };
    const handleChange = e => {
        const { name, value } = e.target;
        oppData[name] = value; // Update the oppData object directly
    }
    let tabs =  ["Qualification", "Information Gathering", "Conversion", "Documents"];

    if (oppData.funnel === 'Re-KYC'){
        tabs = ["Qualification", "Documents"];
    }
    else if (oppData.funnel === 'Referral'){
        tabs = ["Qualification", "Info Gathering", "Documents", "Conversion"];
    }

    useEffect(() => {
        if (!oppData?.lead_id) return;

        if(oppData.funnel==='Referral'){
            fetch(`${import.meta.env.VITE_BASE_URL}/referral_details?lead_id=${oppData.referred_lead_id}`)
            .then((res) => res.json())
            .then((data) => {
                setReferralData(data);
                setInitialPayoutValue(data.payout); // Store the initial value
            })
            .catch((error) => console.error('Error fetching details:', error));
        }
    }, [oppData?.lead_id]);

    const handlePayoutCheckboxChange = (e) => {
        const isQualified = e.target.checked ? 1 : 0;
        setReferralData(prev => ({
            ...prev,
            payout: isQualified
        }));
        
        // Show save buttons only if the value has changed from initial
        setShowSaveButtons(isQualified !== initialPayoutValue);
    };

    const handleCancel = () => {
        // Revert to initial value
        setReferralData(prev => ({
            ...prev,
            payout: initialPayoutValue
        }));
        setShowSaveButtons(false);
    };

    const handleSubmit = async () => {
        try {
            const response = await fetch(`${import.meta.env.VITE_BASE_URL}/update_referral_payout`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    lead_id: oppData.referred_lead_id,
                    payout: referralData.payout
                }),
            });

            if (response.ok) {
                setInitialPayoutValue(referralData.payout); // Update initial value
                setShowSaveButtons(false);
                setShowConfirmationModal(false);
                toast.success('Payout qualification updated successfully');
            } else {
                throw new Error('Failed to update payout qualification');
            }
        } catch (error) {
            console.error('Error updating payout qualification:', error);
            toast.error('Failed to update payout qualification');
        }
    };

    return(
        <div className="w-full flex justidy-between items-center ml-2">
            <div className="p-4 rounded-3xl w-full mr-2">
                <div className="flex space-x-6 ml-3">
                    {tabs.map((tab, index) => (
                        <button
                            key={index}
                            onClick={() => {
                                setActiveTab(index);
                            }}
                            className={`relative text-md font-medium pb-1 transition-all mb-3 ${
                                activeTab === index ? "text-black border-b-4 pl-2 pr-2 border-yellow-300" : "text-gray-500"
                            }`}
                        >
                            {tab}
                        </button>
                    ))}
                </div>
                {activeTab === 0 && (
                    <div className="w-full bg-white p-7 rounded-3xl">
                        <div className="flex justify-between items-start">
                            <div className="flex items-center">
                                <p className="font-bold text-2xl text-[#1E293B]">Qualification</p>
                            </div>
                        </div>
                        <div className="flex items-center mt-5">
                            <div className="border-b border-gray-200 pb-2 w-full flex">
                                <span className="w-1/5 font-bold text-[#475569]">MM Account ID</span>
                                {isEditing ? (
                                    <input
                                        type="text"
                                        name='mm_acc_id'
                                        disabled
                                        value={oppData.mm_acc_id}
                                        onChange={handleChange}
                                        className="flex-1 text-[#475569]"
                                    />
                                ):(
                                    <>
                                    <div className="flex-1 flex items-center">
                                        <span className="flex-1 text-[#475569]">{oppData.mm_acc_id}</span>
                                    </div>
                                    <button
                                        onClick={() => {
                                            navigator.clipboard.writeText(oppData.mm_acc_id);
                                            toast.success('Copied to clipboard!');
                                        }}
                                        className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        >
                                            <img src="/icons/content_copy.svg" className='size-6'/>
                                    </button>
                                    </>
                                )}
                            </div>
                        </div>
                        
                        {oppData.funnel !== 'Referral' && (
                            <div className="flex items-center mt-5">
                                <div className="border-b border-gray-200 pb-2 w-full flex">
                                    <span className="w-1/5 font-bold text-[#475569]">Opportunity Remark</span>
                                {isEditing ? (
                                    <input
                                        type="text"
                                        name='opp_name'
                                        value={oppData.opp_name}
                                        onChange={handleChange}
                                        className="flex-1"
                                    />
                                ):(
                                    <>
                                    <div className="flex-1 flex items-center">
                                            <span className="flex-1 text-[#475569]">{oppData.opp_name}</span>
                                    </div>
                                        <button
                                            onClick={() => {
                                                navigator.clipboard.writeText(oppData.opp_name);
                                                toast.success('Copied to clipboard!');
                                            }}
                                            className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        >
                                            <img src="/icons/content_copy.svg" className='size-6'/>
                                        </button>
                                    </>
                                )}
                                </div>
                            </div>
                        )}
                        
                        <div className="flex items-center mt-5">
                            <div className="border-b border-gray-200 pb-2 w-full flex">
                                <span className="w-1/5 font-bold text-[#475569]">Account Name</span>
                                {isEditing ? (
                                    <input
                                        type="text"
                                        name='name'
                                        value={oppData.name}
                                        onChange={handleChange}
                                        className="flex-1 text-[#475569]"
                                    />
                                ):(
                                    <>
                                    <div className="flex-1 flex items-center">
                                        <span className="flex-1 text-[#475569]">{oppData.name}</span>
                                    </div>
                                    <button
                                        onClick={() => {
                                            navigator.clipboard.writeText(oppData.name);
                                            toast.success('Copied to clipboard!');
                                        }}
                                        className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    >
                                        <img src="/icons/content_copy.svg" className='size-6'/>
                                    </button>
                                    </>
                                )}
                            </div>
                        </div>
                        {(oppData.funnel === 'Insurance') && (
                            <div className="flex items-center mt-5">
                                <span className="border-b border-gray-200 pb-2 w-full flex">
                                    <span className="w-1/5 font-bold text-[#475569]">Ref ID</span>
                                    <span className="flex-1 text-[#475569]">{oppData?.ref_id || "N/A"}</span>
                                    <button
                                        onClick={() => {
                                            navigator.clipboard.writeText(oppData?.name);
                                            toast.success('Copied to clipboard!');
                                        }}
                                        className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    >
                                        <img src="/icons/content_copy.svg" className='size-6'/>
                                    </button>
                                </span>
                            </div>
                        )}

                        {(oppData.funnel === 'Referral') && (
                        <div>
                            <br></br>
                            {/* <div></div> */}
                            {/* <hr className="border-t-4 border-gray-400 my-4"></hr> */}
                            <div className="flex justify-between items-start mt-2">
                                <div className="flex items-center">
                                    <p className="font-bold text-2xl text-[#1E293B]">Referred Details</p>
                                </div>
                            </div>
                            <div className="flex items-center mt-5">
                                <span className="border-b border-gray-200 pb-2 w-full flex">
                                    <span className="w-1/5 font-bold text-[#475569]">Referred Company Name</span>
                                    <span className="flex-1 text-[#475569]">{referralData.company_name || "N/A"}</span>
                                </span>
                            </div>
                            <div className="flex items-center mt-5">
                                <span className="border-b border-gray-200 pb-2 w-full flex">
                                    <span className="w-1/5 font-bold text-[#475569]">Lead Source</span>
                                    <span className="flex-1 text-[#475569]">{referralData.lead_source || "N/A"}</span>
                                </span>
                            </div>
                            <div className="flex items-center mt-5">
                                <span className="pb-2 w-full flex">
                                    <span className="font-bold w-1/5 text-[#475569]">Qualified for payout</span>
                                    <input
                                        type="checkbox"
                                        checked={referralData.payout === 1}
                                        onChange={handlePayoutCheckboxChange}
                                        className="h-5 w-5 text-blue-600 rounded focus:ring-blue-500"
                                    />
                                </span>
                            </div>
                            
                            {/* Save/Cancel buttons that appear when value changes */}
                            {showSaveButtons && (
                                <div className="flex justify-end space-x-4 mt-6">
                                    <button
                                        onClick={handleCancel}
                                        className="px-4 py-2 border border-gray-300 rounded-3xl text-gray-700 hover:bg-gray-100"
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        onClick={() => setShowConfirmationModal(true)}
                                        className="px-4 py-2 bg-yellow-300 text-black rounded-3xl hover:bg-yellow-400"
                                    >
                                        Save Changes
                                    </button>
                                </div>
                            )}
                            
                            {/* Confirmation Modal */}
                            {showConfirmationModal && (
                                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center text-center">
                                    <div className="bg-white p-6 rounded-lg w-1/4">
                                        <div className="flex justify-center mb-2 pt-6">
                                            <img src="/icons/edit.svg" className='size-11' />
                                        </div>
                                        <h1 className="text-2xl font-bold mb-3">Confirm Payout Qualification Update</h1>
                                        <p>Are you sure you want to update the payout qualification status?</p>
                                        <div className="mt-6 mb-6">
                                            <button
                                                className="text-black underline hover:text-gray-600 focus:outline-none"
                                                onClick={() => setShowConfirmationModal(false)}
                                            >
                                                <b>No, Don't Update</b>
                                            </button>
                                        </div>
                                        <button
                                            className="bg-yellow-300 text-black py-4 w-full rounded-3xl hover:bg-yellow-400"
                                            onClick={handleSubmit}
                                        >
                                            <b>Yes, Update</b>
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                        )}
                    </div>
                )}
                {/* Information Gathering Tab for other funnels, documents tab for Re-KYC */}
                {activeTab === 1 && (
                    oppData.funnel === 'Re-KYC' ? (
                        <DocumentsTab leadID={oppData.lead_id} funnel={oppData.funnel} />
                    ) : (
                        <OpportunityInfoTab funnel={oppData.funnel} oppID={oppData.sub_id} oppData={oppData}/>
                    )
                )}
                {activeTab === 2 && (
                    oppData.funnel === 'Referral' ? (
                        <DocumentsTab leadID={oppData.referred_lead_id} funnel = {oppData.funnel}/>
                    ) : (
                        <DocumentsTab leadID={oppData.lead_id} funnel = {oppData.funnel}/>
                    )
                    
                )}
                {activeTab === 3 && (
                    <ConversionTab oppData={oppData} />
                )}
            </div>
        </div>
    )
};
export default OpportunityDetails;